module.exports = __webpack_public_path__ + "img/home1.dc51aa4b.jpg";